import gql from 'graphql-tag';

export const TASKS_QUERY = gql`
  query TasksHome(
    $status: String
    $name: String
    $timeAfter: String
    $timeBefore: String
    $cropId: String
    $first: Int!
    $after: String
  ) {
    task_groups(
      filters: [
        { name: "task.task_status", operator: "in", value: $status }
        { name: "task.task_name", operator: "in", value: $name }
        { name: "task.task_time", operator: ">=", value: $timeAfter }
        { name: "task.task_time", operator: "<=", value: $timeBefore }
        { name: "task.crop_id", operator: "in", value: $cropId }
      ]
      orderBy: [
        { name: "task.task_time", direction: "asc" }
        { name: "task.task_name", direction: "asc" }
      ]
      first: $first
      after: $after
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
      edges {
        node {
          tasks {
            id
            task_name
            task_status
            task_time
            task_completed_time
            planting {
              id
              order_id
              trays_rounded
              planting_time
            }
          }
          crop {
            id
            crop_name
          }
        }
      }
    }
  }
`;

export const TASK_NAMES_QUERY = gql`
  query TaskNames {
    task_names
  }
`;
